import catalog from './featureCatalog.json';

export const CATALOG = catalog;
export const NODES = catalog.nodes;
export const ALL_ACTIONS = catalog.actions;

const byKey = new Map(NODES.map((node) => [node.key, node]));

export const nodeOf = (key) => byKey.get(key) || null;
export const isKnownKey = (key) => byKey.has(key);
export const isGrantable = (key) => {
  const node = byKey.get(key);
  return !!node && node.grantable === 'tenant';
};
export const actionsOf = (key) => {
  const node = byKey.get(key);
  return node ? node.actions.slice() : [];
};
export const supportsAction = (key, action) => actionsOf(key).includes(action);
export const tenantNodes = () => NODES.filter((n) => n.grantable === 'tenant');
export const allTenantKeys = () => tenantNodes().map((n) => n.key);
export const frontendLegacyOf = (key) => {
  const node = byKey.get(key);
  return node ? node.frontendLegacy : null;
};
export const tecTenantAllows = (key, action) => {
  const node = byKey.get(key);
  return !!(node && node.tecTenant && node.tecTenant[action] === true);
};
